<template>
<div v-if="inputValue">
  <v-form>
   
  <div class="my-8">
    <h5>{{ $t('nurseryHours.extendedPatternName') }}</h5>
    <v-text-field
      v-model="inputValue.patternTitle"
      variant="outlined"
      hide-details=""
      density="compact"
    ></v-text-field>
  </div>

  <div class="my-8">
    <h5>{{ $t('nurseryHours.amount') }}</h5>
    <v-text-field
      v-model="inputValue.billingAmount"
      :rules="[isSafeInteger, isNotMinus]"
      variant="outlined"
      density="compact"
      hide-details=""
      type="number"
      suffix="円"
    ></v-text-field>
  </div>

 
  <div class="my-8">
    <h5>{{ $t('nurseryHours.extendedCareStartTime') }}</h5>
    <time-input
      :hour="inputValue.extendedChildcareStartingHour"
      @hour="inputValue.extendedChildcareStartingHour = Number($event)"
      :minute="inputValue.extendedChildcareStartingMinute"
      @minute="inputValue.extendedChildcareStartingMinute = Number($event)"
    ></time-input>
  </div>

  <div class="my-12 d-flex justify-center">
    <v-btn
      @click="updatePattern"
      v-if="isUpdatable"
      :loading="isLoading"
      color="primary"
      variant="flat"
      large
    >{{ $t('common.save') }}</v-btn>
    <v-btn
      @click="createPattern"
      v-else
      :loading="isLoading"
      color="primary"
      variant="flat"
      large
    >{{ $t('common.create') }}</v-btn>
  </div>

  </v-form>

</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { nurseryHoursModule, CreateMonthlyPatternInput } from '@/store/dataModules/nurseryHoursModule';
import LocalDataService from '@/service/LocalDataService';
import Swal from 'sweetalert2';
import TimeInput from '@/components/organisms/nursery-hours/TimeInput.vue'
import ValidationMixin from '@/mixins/ValidationMixin';

export default defineComponent({
  name: 'MonthlyPatternContainer',

  mixins: [ValidationMixin],

  components: {
    TimeInput,
  },

  data() {
    return {
      isLoading: false,
    }
  },

  mounted() {
    if (!this.isUpdatable) {
      this.initValues();
    }
  },

  computed: {
    inputValue: {
      get(): CreateMonthlyPatternInput | null {
        return nurseryHoursModule.monthlyPatternInput;
      },
      set(value: CreateMonthlyPatternInput) {
        nurseryHoursModule.setMonthlyPatternInput(value);
      },
    },
    isUpdatable: function(): boolean {
      return (this.$route.query && this.$route.query.category != null); 
    },
  },

  methods: {
    initValues() {
      const nurseryId = LocalDataService.getNurseryId();
      if (nurseryId) {
        nurseryHoursModule.setMonthlyPatternInput({
          nurseryId: nurseryId,
          patternTitle: this.$t('nurseryHours.defaultPatternTitle') as string,
          billingAmount: 0,
          extendedChildcareStartingHour: 6,
          extendedChildcareStartingMinute: 0,
        });
      }
    },
    async createPattern() {
      this.isLoading = true;
      const response = await nurseryHoursModule.createMonthlyPattern();
      if (response) {
        Swal.fire({
          title: this.$t('nurseryHours.createSuccess') as string,
        });
        this.$router.push({ path: '/nursery-hours' });
      }
      this.isLoading = false;
    },
    async updatePattern() {
      this.isLoading = true;
      const patternId = this.$route.query?.patternId;
      if (patternId) {
        const response = await nurseryHoursModule.updateMonthlyPattern({
          patternId: String(patternId),
        });
        if (response) {
          Swal.fire({
            title: this.$t('nurseryHours.saveSuccess') as string,
          });
        }
      }
      this.isLoading = false;
    },
  }
})
</script>